export default "__VITE_ASSET__ChqzP2Da__"